import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const myakkaCityConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Myakka City Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Myakka City, FL. Sam\'s Tree Service handles large and dangerous rural trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_myakka_city',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Myakka City',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Myakka City Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring the same level of professionalism 
     to rural properties in <strong>Myakka City</strong> that we bring to every job across 
     Southwest Florida. Large acreage properties, thick tree lines, and the massive oaks 
     and pines common to this area create unique challenges especially after storms roll 
     through and leave behind downed trees, split trunks, and dangerous overhang across 
     driveways, barns, and homes.`,

    `We specialize in <strong>large scale and rural tree removal</strong> including 
     full tree takedowns on wide lots, clearing storm debris from driveways and structures, 
     trimming large canopies threatening buildings or fencing, and handling the kind of 
     heavy, complex work that requires serious equipment and experience. We come prepared 
     for the job no matter the size.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable tree care 
     throughout <strong>Myakka City</strong> and the surrounding <strong>East Manatee 
     and Sarasota</strong> rural communities keeping your land, structures, and trees 
     safe and well maintained year round.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Myakka City, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_MyakkaCity = () => <LocationPage config={myakkaCityConfig} />;
export default Services_MyakkaCity;
